import { CheckIcon } from '@primer/octicons-react';
import { graphql, useFragment } from 'react-relay';

import {
  MATUserOrganizationCreateDialog_matOrganization$key,
} from '../../../relay/__generated__/MATUserOrganizationCreateDialog_matOrganization.graphql';
import {
  MATUserOrganizationCreateDialog_userOrganizationCreateMutation,
} from '../../../relay/__generated__/MATUserOrganizationCreateDialog_userOrganizationCreateMutation.graphql';
import Button from '../../core/Button';
import Dialog, { DialogProps } from '../../core/Dialog';
import FormLayout from '../../core/FormLayout';
import MutationFormik, { MutationFormikProps } from '../../core/MutationFormik';
import NonFieldError from '../../core/NonFieldError';
import TextField from '../../core/TextField';
import View from '../../core/View';
import InternalUserPaginatorSearchOverlayTokenField from '../../internalUser/InternalUserPaginatorSearchOverlayTokenField';

const MATUserOrganizationCreateDialog_matOrganization = graphql`
  fragment MATUserOrganizationCreateDialog_matOrganization on MATOrganization {
    id
  }
`;

type Props = { matOrganization: MATUserOrganizationCreateDialog_matOrganization$key } & DialogProps &
  Pick<
    MutationFormikProps<MATUserOrganizationCreateDialog_userOrganizationCreateMutation>,
    'config' | 'onSubmit' | 'connections'
  >;

const MATUserOrganizationCreateDialog = ({ matOrganization, config, onSubmit, connections, ...props }: Props) => {
  const { id } = useFragment(MATUserOrganizationCreateDialog_matOrganization, matOrganization);

  return (
    <Dialog {...props}>
      <Dialog.Header>
        <View sx={{ fontSize: 3, fontWeight: 'bold' }}>학생 초대하기</View>
      </Dialog.Header>
      <MutationFormik<MATUserOrganizationCreateDialog_userOrganizationCreateMutation>
        mutation={graphql`
          mutation MATUserOrganizationCreateDialog_userOrganizationCreateMutation(
            $input: MATUserOrganizationCreateInput!
          ) {
            userOrganizationCreate(input: $input) {
              id
            }
          }
        `}
        initialValues={{ organization: id }}
        config={config}
        onSubmit={onSubmit}
        connections={connections}
      >
        {({ handleSubmit, values, setFieldValue }, { nonFieldErrorRef, scrollContainerRef }) => (
          <>
            <Dialog.Body ref={scrollContainerRef}>
              <FormLayout>
                <NonFieldError ref={nonFieldErrorRef} />
                <InternalUserPaginatorSearchOverlayTokenField
                  label={'사용자'}
                  name={'user'}
                  required
                  value={typeof values.user === 'string' && values.user ? [values.user] : []}
                  onChange={(selected) => {
                    setFieldValue('user', selected);
                  }}
                />
                <TextField label={'이름'} name={'realname'} placeholder={'이름 입력 (선택)'} />
              </FormLayout>
            </Dialog.Body>
            <Dialog.Footer>
              <Button variant={'primary'} leadingIcon={CheckIcon} onClick={() => handleSubmit()}>
                초대하기
              </Button>
            </Dialog.Footer>
          </>
        )}
      </MutationFormik>
    </Dialog>
  );
};

export default MATUserOrganizationCreateDialog;
